import { jsxs as b, jsx as l } from "react/jsx-runtime";
import { useMultiStyleConfig as j, Stack as C } from "@chakra-ui/react";
import { FormControl as S } from "../FormControl/FormControl.mjs";
import { FileUploadDropZone as _ } from "./components/FileUploadDropZone/FileUploadDropZone.mjs";
import { FileList as k } from "./components/FileList/FileList.mjs";
const N = ({
  name: o,
  onRemoveFile: m,
  controlClassName: a,
  controlStyleProps: n,
  "data-testid": t,
  error: e,
  files: s = [],
  formHelperText: f,
  hideFileActionButtons: F = !1,
  hideOptionalLabel: u = !1,
  hideUploadAllButton: d = { above: !0, below: !0 },
  id: r = o,
  isDisabled: i,
  isReadOnly: p,
  isRequired: c,
  label: g,
  onUploadAllClick: h,
  ...x
}) => {
  const U = j("FileUpload");
  return /* @__PURE__ */ b(C, { spacing: { base: 2, md: 4 }, __css: U.container, children: [
    /* @__PURE__ */ l(
      S,
      {
        name: o,
        hideOptionalLabel: u,
        id: r,
        error: e,
        label: g,
        isDisabled: i,
        isReadOnly: p,
        isRequired: c,
        formHelperText: f,
        "data-testid": t && `${t}-control`,
        className: a,
        ...n,
        children: /* @__PURE__ */ l(
          _,
          {
            name: o,
            id: r,
            isDisabled: i,
            isReadOnly: p,
            isRequired: c,
            "data-testid": t,
            error: e,
            ...x
          }
        )
      }
    ),
    s.length > 0 && /* @__PURE__ */ l(
      k,
      {
        id: r,
        name: o,
        "data-testid": t,
        onRemoveFile: m,
        files: s,
        hideFileActionButtons: F,
        onUploadAllClick: h,
        hideUploadAllButton: d
      }
    )
  ] });
};
export {
  N as FileUpload
};
